goog.provide("shadow.js.shim.module$$mui$material$Autocomplete");
goog.provide("module$shadow_js_shim_module$$mui$material$Autocomplete");
shadow.js.shim.module$$mui$material$Autocomplete = shadow.js.nativeProvides["@mui/material/Autocomplete"] = shadow$bridge("@mui/material/Autocomplete");
module$shadow_js_shim_module$$mui$material$Autocomplete.default = shadow.js.shim.module$$mui$material$Autocomplete;
